module.exports = __webpack_public_path__ + "img/LogoVEQ_Gris.71ba9436.png";